import { Tab } from "@headlessui/react";
import { useMedia } from "shared/providers";
import { useProgressContext } from "providers/ProgressContext";

import Drawer from "react-modern-drawer";
import {
  IconButton,
  IconButtonSize,
  IconButtonVariant
} from "shared/components";
import { PropertyManagementSystemSync } from "shared/components/PropertyManagementSystemSync";
import { XClose } from "untitledui-js-base";
import { PMSLedger } from "views/renters/components/Table/RowDrawer/PMSLedger";
import { PMSRenterDetails } from "views/renters/components/Table/RowDrawer/PMSRenterDetails";
import { StatusDetails } from "views/renters/components/Table/RowDrawer/StatusDetails";
import { AlgoliaUser } from "views/renters/types";

type Props = {
  showRowDrawer: boolean;
  onClose: () => void;
  selectedRowData: AlgoliaUser | null;
};

export const RowDrawer = ({
  showRowDrawer,
  onClose,
  selectedRowData
}: Props) => {
  const { handleRequestPMSsync, pmsStatus } = useProgressContext();

  const { isMobile } = useMedia();

  return (
    <Drawer
      className="flex h-full flex-col overflow-y-auto rounded-l-lg"
      direction="right"
      onClose={onClose}
      open={showRowDrawer}
      size={isMobile ? 360 : 600}
    >
      {!!selectedRowData ? (
        <>
          {/* Header */}
          <div className="flex items-center justify-between border-b border-alpha-40 px-6 py-4 pb-4">
            <p className="text-xl font-bold text-content-1000">
              {selectedRowData.customer.firstName}{" "}
              {selectedRowData.customer.lastName}
            </p>
            <IconButton
              variant={IconButtonVariant.BASE}
              size={IconButtonSize.SM}
              borderLess
              Icon={XClose}
              onClick={onClose}
            />
          </div>
          {/* Body */}
          <div className="flex h-full flex-col gap-4 px-6 py-4">
            {/* Statuses */}
            <div className="flex h-fit flex-col">
              <StatusDetails selectedRowData={selectedRowData} />
            </div>
            {/* PMS Stuff */}
            <div className="flex h-full flex-col">
              <Tab.Group>
                <div className="border-b border-alpha-100 text-sm">
                  <Tab.List className="flex space-x-4">
                    {["PMS Renter Details", "PMS Ledger"].map((tab) => {
                      return (
                        <Tab
                          key={tab}
                          className={({ selected }) =>
                            `px-2 py-2 outline-none ${
                              selected
                                ? "border-b-2 border-primary-500 pb-[6px] font-bold text-primary-500"
                                : "font-medium text-content-400"
                            }`
                          }
                        >
                          {tab}
                        </Tab>
                      );
                    })}
                  </Tab.List>
                </div>
                <Tab.Panels className="mb-6 mt-4 h-full">
                  <PropertyManagementSystemSync
                    isSyncing={pmsStatus?.status === "running"}
                    handleRequestSync={handleRequestPMSsync}
                    lastSuccessSyncedAt={pmsStatus?.last_successful_sync}
                  />
                  <Tab.Panel>
                    <PMSRenterDetails selectedRowData={selectedRowData} />
                  </Tab.Panel>
                  <Tab.Panel as="div" className="h-full">
                    <PMSLedger selectedRowData={selectedRowData} />
                  </Tab.Panel>
                </Tab.Panels>
              </Tab.Group>
            </div>
          </div>
        </>
      ) : null}
    </Drawer>
  );
};
